module.exports = __webpack_public_path__ + "media/images/unsplash_img_02-p-130x130q80-b938040d7e50344062e90d8a45dc06e3.jpeg";